import {
	getGetProjectNetworkQueryOptions,
	getListNetworkConnectionsQueryOptions,
	getListNetworkNodesQueryOptions,
	getListProjectNetworksQueryOptions,
	type Network,
	type Project,
} from '@amarantos/api-client'
import type { QueryClient } from '@tanstack/react-query'

import { WHOLE_LIST_PER_PAGE } from '@/utils/whole-list'

/**
 * The entry panel needs every node for name resolution (and every connection for the entered
 * list), so both lists are fetched as one API-max page rather than paginated. Shared with the
 * definition route's loader — the params must match for the prefetch to hit the same query key.
 */
export const connectionEntryListParams = { per_page: WHOLE_LIST_PER_PAGE } as const

/**
 * The networks step opens on the method choice, which lists the project's networks — prefetched so
 * the step is warm on link hover, same params as `NetworkEntryMethodChoice` so the keys match.
 */
export function ensureNetworkEntryChoiceData(queryClient: QueryClient, projectId: Project['id']): void {
	queryClient.ensureQueryData(getListProjectNetworksQueryOptions(projectId, connectionEntryListParams))
}

export function ensureConnectionEntryData(
	queryClient: QueryClient,
	projectId: Project['id'],
	networkId: Network['id'],
): void {
	queryClient.ensureQueryData(getGetProjectNetworkQueryOptions(projectId, networkId))
	queryClient.ensureQueryData(getListNetworkNodesQueryOptions(networkId, connectionEntryListParams))
	queryClient.ensureQueryData(getListNetworkConnectionsQueryOptions(networkId, connectionEntryListParams))
}
